import { render, staticRenderFns } from "./ot-checkbox-group-wrapper.vue?vue&type=template&id=9b5e9602&scoped=true&"
import script from "./ot-checkbox-group-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-checkbox-group-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-checkbox-group-wrapper.vue?vue&type=style&index=0&id=9b5e9602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5e9602",
  null
  
)

export default component.exports